import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { DataStateService } from '../core/services/data-state.service';
import { DEFAULT_DEALER_RESOURCE_VALUES } from '../dealers/custom-dealer-resource-map';
import { UiStateService } from '../core/services/ui-state-service';
import { takeUntil } from 'rxjs/operators';
import { BaseComponent } from '../shared/base.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent extends BaseComponent {
  public logoLink: string = DEFAULT_DEALER_RESOURCE_VALUES.logoLink;
  constructor(private router: Router,
    private state: DataStateService,
    private uiState: UiStateService) {
    super();
    this.uiState.customDealerResources$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((resources) => {
        this.logoLink = `data:image/png;base64,${resources?.logoLink || DEFAULT_DEALER_RESOURCE_VALUES.logoLink}`
      });
  }



  public onHeaderClicked() {
    this.router.navigate([this.state.landingPagePath]);
  }
}
